module.exports = __webpack_public_path__ + "media/images/game/categories/vzdelavani_a_rozvoj-4a605a0452a3a0a7d03d6bc544b846f7.png";